import { PartialType, PickType } from '@nestjs/swagger';
import { RepairPaymentDto } from './repair-payment.dto';
import { RepairPaymentUpdatableInterface } from '../interfaces/repair-payment-updatable.interface';

export class RepairPaymentUpdateDto
  extends PartialType(
    PickType(RepairPaymentDto, [
      'id',
      'repairPaymentDate',
      'isApprovedHours',
      'timeIn',
      'timeOut',
      'contractorId',
      'approvedHours',
      'paid',
      'loggedGeo',
      'approvedGeo',
      'loggedGeoAccuracy',
      'approvedGeoAccuracy',
    ]),
  )
  implements RepairPaymentUpdatableInterface {}
